import { render, staticRenderFns } from "./EditAgreementContainer.vue?vue&type=template&id=58fd1388&scoped=true&"
import script from "./EditAgreementContainer.vue?vue&type=script&lang=ts&"
export * from "./EditAgreementContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fd1388",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
